
import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosHeaders } from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

const API_URL = `${BASE_URL}/api`


const api: AxiosInstance = axios.create({
    baseURL: API_URL,
});

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('flashroom_roomToken');
    const hasAuthorization =
        config.headers instanceof AxiosHeaders
            ? config.headers.has('Authorization')
            : !!(config.headers as any)?.Authorization || !!(config.headers as any)?.authorization;

    if (token && !hasAuthorization) {
        // Axios v1 uses AxiosHeaders internally; handle both cases
        if (config.headers instanceof AxiosHeaders) {
            config.headers.set('Authorization', `Bearer ${token}`);
        } else {
            // config.headers might be a plain object or undefined
            config.headers = new AxiosHeaders(config.headers);
            config.headers.set('Authorization', `Bearer ${token}`);
        }
    }

    return config;
});

export default api;
